import { useEffect } from 'react'

import {
  WS_MESSAGE_TYPE,
  sendWsMessage,
  subscribeWsOpen,
} from '#/shared/lib/ws'

/**
 * Subscribes the open conversation to its server-side "room" so inbound SMS
 * (and future calls) arrive live for anyone viewing the thread — independent of
 * notify-flags. Unsubscribes on unmount and re-subscribes on reconnect, since
 * the server drops room subscriptions when the socket drops. Only the
 * `conversation_id` is sent; the server namespaces the room by org from the JWT.
 */
export function useConversationLiveSync(
  conversationId: string | undefined,
): void {
  useEffect(() => {
    if (!conversationId) return

    const subscribe = () =>
      sendWsMessage({
        type: WS_MESSAGE_TYPE.subscribeConversation,
        conversation_id: conversationId,
      })

    subscribe()
    const offReconnect = subscribeWsOpen(subscribe)

    return () => {
      offReconnect()
      sendWsMessage({
        type: WS_MESSAGE_TYPE.unsubscribeConversation,
        conversation_id: conversationId,
      })
    }
  }, [conversationId])
}
